// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"169":"5f08d64f","275":"d196588e","318":"c4e61fca","724":"ead9db3c","810":"e9aaaad4","942":"12234005"}[chunkId] + ".chunk.js";
};